import { render } from "./TaskRowArchive.vue?vue&type=template&id=7455f110"
import script from "./TaskRowArchive.vue?vue&type=script&lang=js"
export * from "./TaskRowArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__